/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
/**
 *
 * @export
 * @interface AllShipmentsSlice
 */
export interface AllShipmentsSlice {
  /**
   *
   * @type {string}
   * @memberof AllShipmentsSlice
   */
  label: string;
  /**
   *
   * @type {number}
   * @memberof AllShipmentsSlice
   */
  value: number;
}

/**
 * Check if a given object implements the AllShipmentsSlice interface.
 */
export function instanceOfAllShipmentsSlice(
  value: object,
): value is AllShipmentsSlice {
  if (!("label" in value) || value["label"] === undefined) return false;
  if (!("value" in value) || value["value"] === undefined) return false;
  return true;
}

export function AllShipmentsSliceFromJSON(json: any): AllShipmentsSlice {
  return AllShipmentsSliceFromJSONTyped(json, false);
}

export function AllShipmentsSliceFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): AllShipmentsSlice {
  if (json == null) {
    return json;
  }
  return {
    label: json["label"],
    value: json["value"],
  };
}

export function AllShipmentsSliceToJSON(json: any): AllShipmentsSlice {
  return AllShipmentsSliceToJSONTyped(json, false);
}

export function AllShipmentsSliceToJSONTyped(
  value?: AllShipmentsSlice | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    label: value["label"],
    value: value["value"],
  };
}
